/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Act_CancelInputs */

const vi_cdo_act_cancel = /** @type {(inputs: Cdo_Act_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ đơn`)
};

/**

* @param {Cdo_Act_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_act_cancel = /** @type {((inputs?: Cdo_Act_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Act_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_act_cancel(inputs)
});